export default __webpack_public_path__ + "static/FF_3D-BERRY-4-ced5455449ecd5be63e83f7e3d45dc2d.png";